import BaseLayer from "./BaseLayer";
import {plotDisagreementsHelper} from "../utils/map_utils";

class StitchPreRound2Disagreementv2 extends BaseLayer {

    id = "stitchPreRound2Disagreementv2";
    label = "Before";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPreR2Disagreement, textColor} = this.props;
        plotDisagreementsHelper(stitchPreR2Disagreement.result, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchPreRound2Disagreementv2;
